import React from 'react';
import styles from "./ErrorModal.module.sass";
import {Modal} from "react-bootstrap";
import AppContext from "../../contexts/appContext";
import Chat from "../Chat/Chat";
import Button from "../ui/Button/Button";

class ErrorModal extends React.Component {

  static contextType = AppContext;

  hideHandler = () => {
    if (this.context.error.onHide) {
      this.context.error.onHide();
    }

    this.context.setContext({
      ...this.context,
      error: {
        show: false,
        body: null
      }
    });
  };

  render() {
    const iconClassname = [styles.icon, 'icon'];
    if (this.context.error.modalType === 'warning') {
      iconClassname.push('icon-atencao-m', styles.warning);
    } else if (this.context.error.modalType === 'info') {
      iconClassname.push('icon-info-m', styles.warning);
    } else {
      iconClassname.push('icon-erro-m', styles.error);
    }

    return (
      <Modal
        centered
        dialogClassName={styles.modalDialog}
        show={this.context.error.show}
        onHide={this.hideHandler}
      >
        <Modal.Header closeButton/>
        <Modal.Body>
          <i className={iconClassname.join(' ')}/>
          <div className={styles.modalMsg}>
            {this.context.error.msg}
            <span className={styles.additionalInfo}> {this.context.error.additionalMsg}</span>
          </div>
          {
            this.context.error.showOptions &&
            <div className={styles.actions}>
              <Button onClick={() => this.context.error.onBack && this.context.error.onBack()}>Voltar</Button>
              <Button onClick={() => this.context.error.onCancel && this.context.error.onCancel()} selected>Cancelar</Button>
            </div>
          }

          {this.context.error.chat && this.context.product &&
          <Chat
            product={this.context.product}/>
          }
        </Modal.Body>
      </Modal>
    )
  }
}

export default ErrorModal;
